module.exports = __webpack_public_path__ + "img/Logo_ined.909d60cc.svg";